import React, { useState, useEffect } from 'react';
import '../styles/informationCard.css';

import arrow_circle from '../assets/icons/arrow_circle_right.svg';

const InformationCard = ({ title, name, img, type }) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleText = () => {
        setIsExpanded((prev) => !prev);
    };

    return (
        <div className={`information-card ${isMobile && isExpanded ? 'expanded' : ''}`}>
            <img src={img} alt="" className="information-card-bg-img" />
            <div className='information-card-content-wrapper'>
                <div className='information-card-header'>
                    <h1 className='information-card-title'>{title}</h1>
                    <img src={arrow_circle} alt="Arrow Circle" className='information-card-arrow' onClick={toggleText} />
                </div>

                <div className='information-card-content'>
                    <p className='information-card-scientific'>Scientific name:</p>
                    <p className='information-card-scientific-name'>{name}</p>
                </div>
            </div>
            {type === 1 && (!isMobile || isExpanded) && (
                <div className='information-card-text'>
                    <p className='information-card-description'>Fenugreek (Trigonella foenum-graecum) has emerged as a valuable botanical for enhancing muscle endurance and physical performance. Its benefits are primarily attributed to the presence of saponins (notably diosgenin), alkaloids (such as trigonelline), and amino acids (like 4-hydroxyisoleucine), which contribute to multiple physiological effects.</p>
                    <h3 className='information-card-subtitle'>Scientific Superiority of Fenugreek</h3>
                    <ul className='information-card-benefits'>
                        <li className='information-card-benefit'>
                            Enhances Testosterone levels
                        </li>
                        <li className='information-card-benefit'>
                            Supports muscle protein synthesis
                        </li>
                        <li className='information-card-benefit'>
                            Improves Glycogen Utilization
                        </li>
                        <li className='information-card-benefit'>
                            Reduces Exercise-Induced Fatigue
                        </li>
                    </ul>
                    <h3 className='information-card-subtitle'>Boosts libido and physical performance.</h3>
                    <p className='information-card-description'>Some research shows Fenugreek can increase libido, sexual arousal, stamina which is a
                        sign of good testosterone level.</p>
                </div>
            )}
            {type === 2 && (!isMobile || isExpanded) && (
                <div className='information-card-text'>
                    <h3 className='information-card-subtitle'>Scientific superiority of Black Ginger</h3>
                    <h3 className='information-card-subtitle'>Activates AMPK pathways</h3>
                    <p className='information-card-description'>AMPK (AMP – Activated Protein Kinase) is involved in cellular energy regulation.
                        Boosts fat metabolism and helps manage weight – excess body fat can suppress
                        testosterone production</p>
                    <h3 className='information-card-subtitle'>Inhibits PDE 5 enzyme</h3>
                    <p className='information-card-description'>Supports erectile function. Healthy sexual function is tied to optimal testosterone and
                        hormonal balance
                    </p>
                    <h3 className='information-card-subtitle'>Antioxidant properties</h3>
                    <p className='information-card-description'>Reduce oxidative stress in the tests & adrenal glands. Lower oxidative stress can
                        protects Leydig cells, which produce testosterone</p>
                    <h3 className='information-card-subtitle'>Improve physical performance</h3>
                    <p className='information-card-description'>
                        Studies shows black ginger may improve endurance, strength, and muscle
                        performance which in turn supports testosterone through exercise induced production</p>
                </div>
            )}
        </div>
    );
};

export default InformationCard;
